import React from 'react'

import AddUserDialog from './AddUserDialog'
import clsx from 'clsx'
import DeleteIcon from '@material-ui/icons/Delete'
import GlobalFilter from './GlobalFilter'
import IconButton from '@material-ui/core/IconButton'
import { lighten, makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Tooltip from '@material-ui/core/Tooltip'
import { Button, Classes, Elevation, Intent,Overlay,H4 } from "@blueprintjs/core";

const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
}))

const TableToolbar = props => {
  const [isopendelete, setOpenDelete] = React.useState(false)
  const [data_enseignant, setDataEnseignant] = React.useState({})
  const classes = useToolbarStyles()
  const {
    userid,
    numSelected,
    addUserHandler,
    deleteUserHandler,
    id_key,
    preGlobalFilteredRows,
    setGlobalFilter,
    globalFilter,
    data
  } = props
  const ldeleteUserHandler= ()=>
  {
    console.log("id_key");
    console.log(id_key);
    console.log(data[id_key[0]]);
    setDataEnseignant(data[id_key[0]])
    setOpenDelete(true);
  }
  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <AddUserDialog userid={userid} addUserHandler={addUserHandler} />
      {numSelected > 0 ? (
        <Typography
          className={classes.title}
          color="inherit"
          variant="subtitle1"
        >
          {numSelected} Sélectionné(s)
        </Typography>
      ) : (
        <Typography className={classes.title} variant="h6" id="tableTitle">
          
        </Typography>
      )}
      <Overlay isOpen={isopendelete} className={Classes.OVERLAY_SCROLL_CONTAINER} {...props}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H4>Effacer l'enseignant {data_enseignant.nom_enseignant} et toutes ses matières</H4>
                       
                        <p style={{marginTop:20}}>
                           Etes-vous sûr de vouloir effacer toutes les matières et l'enseignant {data_enseignant.nom_enseignant} ?
                        </p>
                                              
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();setOpenDelete(false);}}>Annuler</Button>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{
                              ev.preventDefault();
                              
                              var xhr = new XMLHttpRequest();
                              xhr.overrideMimeType("application/json");
                              /*var formData = new FormData();
                              formData.append('Model.ID', this.props.id_documents);
                              formData.append('nom', this.state.title_lesson);
                              formData.append('id_matiere', this.props.matiere_id);
                              formData.append('description', this.state.lesson_description);
                              formData.append('tag', this.props.id_documents);*/
                              var that=this;
                              xhr.open('GET','/api/public/deleteenseignantbystudent?id_enseignant='+data_enseignant.id_enseignant+'&id_user='+userid)
                              
                              xhr.setRequestHeader("Content-Type", "application/json");

                              //send the form data
                              xhr.send();

                                    xhr.onreadystatechange = function() {
                                        if (xhr.readyState == XMLHttpRequest.DONE) {
                                                      
                                        if(xhr.status==200) 
                                        { 
                                        
                                          console.log(xhr.responseText);
                                          deleteUserHandler();
                                          //that.props.onchildrenevent();
                                          return;
                                          var jsonResponse = JSON.parse(xhr.responseText);
                                          console.log(jsonResponse);
                                          
                                          
                                          
                                        }
                                        if(xhr.status==404) {console.log( {message:"erreur"}); }
                                        if(xhr.status==500) {console.log( {message:"erreur"}); }
                                        
                                        }
                                        setOpenDelete(false);
                                      
                                    }
                              
                              
                              
                              
                              }} style={{ margin: "" }}>
                                Valider
                            </Button>
                            
                            
                        </div>
                    </div>
                </Overlay>
      {numSelected > 0 ? (
        <Tooltip title="Effacer">
          <IconButton aria-label="delete" onClick={ldeleteUserHandler}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <GlobalFilter
          preGlobalFilteredRows={preGlobalFilteredRows}
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
          caption="enseignant(s) et matière(s)..."
        />
      )}
    </Toolbar>
    
  )
}

TableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  addUserHandler: PropTypes.func.isRequired,
  deleteUserHandler: PropTypes.func.isRequired,
  setGlobalFilter: PropTypes.func.isRequired,
  preGlobalFilteredRows: PropTypes.array.isRequired,
  globalFilter: PropTypes.string.isRequired,
}

export default TableToolbar
